import React from 'react';
import { Button, Checkbox, Form, Input } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { useNavigate, Navigate } from 'react-router-dom';
import { ContainerLogin, FormLoginContainer } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import adminActions from 'src/redux/actions/adminActions';
import adminSelectors from 'src/redux/selectors/adminSelectors';
import Loading from 'src/components/Loading';
import CustomForm from 'src/components/CustomForm';
import { LOGIN_FIELDS } from 'src/utils/constants';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const loading = useSelector(adminSelectors.loading);
  const admin = useSelector(adminSelectors.admin);

  const onFinish = (values) => {
    const { email, password } = values;
    dispatch(adminActions.login({ email, password }, () => navigate('/dashboard')));
  };

  return (
    admin
      ?
      <Navigate to='/dashboard' />
      :
      <ContainerLogin>
        <Loading loading={loading} />
        <FormLoginContainer>
          <h1 style={styles.loginHeader}>LOGIN</h1>
          <CustomForm form={form} fields={LOGIN_FIELDS} autoComplete='off' layout='vertical' size="large" style={{ width: '100%' }} onFinish={onFinish} />
        </FormLoginContainer>
      </ContainerLogin >
  )
}

const styles = {
  loginHeader: {
    color: 'white',
    fontSize: 50,
    fontWeight: 'bold'
  },
}

export default Login;